import { getPushCategoryEventHandler } from './AnalyticsGAHelpers';

const CATEGORY = 'notice_events';

enum Actions {
  SELECT = 'select_notice',
}

const push = getPushCategoryEventHandler<Actions>(CATEGORY);

export function selectNotice(link: string) {
  return push(Actions.SELECT, undefined, {
    param1: link
  });
}
